<template>
  <div class="content">
    <!-- <div class="top-background">
    	<div class="home"  @click="goindex">
		  		<a-icon type="home" theme="filled" />
		  		<span>首页</span>
  		</div>
      <div class="main-title">数字化转型赋能职业教育高质量发展</div>
      <div class="main-headline">
        <img src="@/assets/images/new/title-text.png" alt="" />
      </div>
    </div> -->
    <a-form class="form" :form="form">
      <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input  placeholder="请设置用户账号" v-decorator="['username', validatorRules.username]" />
         
      </a-form-item>
      <a-form-item
        label="密码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        hasFeedback
      >
        <a-input-password
          type="password"
          placeholder="密码由6位数字、大小写字母和特殊符号组成!"
          v-decorator="['password', validatorRules.password]"
        />
      </a-form-item>

      <a-form-item
        label="确认密码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        hasFeedback
      >
        <a-input-password
          type="password"
          @blur="handleConfirmBlur"
          placeholder="请确认登录密码"
          v-decorator="['confirmpassword', validatorRules.confirmpassword]"
        />
      </a-form-item>
      <a-form-item label="省" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select
          style="width: 180px"
          @change="provinceChange"
          v-decorator="['provincecode', validatorRules.provincecode]"
          :filterOption="filterOption" showSearch
        >
          <a-select-option
            v-for="(item, index) in provinceList"
            :key="index"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-form-item class="city">
          <div>
            <span>市:</span>
            <a-select
              style="width: 180px"
              @change="handleChange"
              v-decorator="['citycode', {}]"
              :filterOption="filterOption" showSearch
            >
              <a-select-option
                v-for="(items, i) in cityList"
                :key="i"
                :value="items.id"
              >
                {{ items.name }}
              </a-select-option>
            </a-select>
          </div>
           <!--<span class="tiplabel" style="top:5px;"></span>-->
        </a-form-item>
      </a-form-item>
      <a-form-item
        label="学校名称"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
      <a-select
      	allowClear
		    show-search
		    v-decorator="['realname', validatorRules.realname]"
		    placeholder="请输入学校名称"
		    :default-active-first-option="false"
		    :show-arrow="false"
		    :filter-option="false"
		    :not-found-content="null"
		    @search="handleSearch"
		    @change="handleChanges"
		    :disabled="disabled"
		  >
		    <a-select-option v-for="d in schoollist" :key="d.name">
		      {{ d.name }}
		    </a-select-option>
  			</a-select>
  			<!--<span class="tiplabel" style="width:130px;right:-150px;">学校名称可输入关键字搜索或者完全手动输入</span>-->
  			 <span class="tiplabel" style="width:150px;right:-170px;">先选择省市,学校名称可输入关键字搜索或完全手动输入</span>
        <!--<a-input placeholder="请输入学校名称" v-decorator="['realname', {}]" />-->
      </a-form-item>
      <a-form-item label="地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input placeholder="请输入地址" v-decorator="['address', validatorRules.address]" />
      </a-form-item>
      <a-form-item label="联系人姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input placeholder="请输入联系人姓名" v-decorator="['concactuser', validatorRules.concactuser]" />
      </a-form-item>
      <a-form-item label="联系人电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input placeholder="请输入电话" v-decorator="['telephone', validatorRules.telephone]" />
        <!-- <span class="tiplabel">联系人手机号用于接受验证码</span> -->
         <span class="tiplabel">联系人手机号</span> 
      </a-form-item>
      <!-- <a-form-item
        class="verification-code"
        label="短信验证码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          placeholder="请输入验证码"
          v-decorator="['verificationCode', validatorRules.verificationCode]"
        />
        <div
          class="verification-code-text"
          @click="getVerificationCode($event)"
          v-show="ishow"
        >
         <span>|&nbsp;&nbsp;获取验证码</span> 
         <div class="slideimg" v-if="visible">
         	 <div class="slidesc"></div>
         	 <div class="slidexz">
         	 <slide-verify
         	 	ref="slideBack"
         	 	 :l="42"
            :r="10"
            :w="310"
            :h="155"
            :imgs="imgs"
            slider-text="向右滑动"
            @success="onSuccess"
            @fail="onFail"
            @refresh="onRefresh"
            ></slide-verify>
           </div>
         </div>
        </div>
         <div
          class="verification-code-text"
          v-show="!ishow"
        >
         <span>|&nbsp;{{this.countdown}}&nbsp;</span> 
        </div>
      </a-form-item> -->
      <a-form-item>
        <div class="register-button" @click="goRegister">注&nbsp;&nbsp;册</div>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { getAction,postAction,mhSchool,getNoteCode} from "@/api/index";
import md5 from "md5";
export default {
  data() {
    return {
    	visible:false,
    	ishow:true,
    	imgs:[
    	   require("../../assets/a.png"),
    	   require("../../assets/b.png"),
    	   require("../../assets/c.png"),
    	   require("../../assets/d.png"),
    	   require("../../assets/e.png"),
    	   require("../../assets/f.png"),
    	],
      validatorRules: {
      	username:{
      		rules: [
            {
              required: true,
              message: "请设置用户名",
            },
          ],
      	},
        password: {
          rules: [
            {
              required: true,
              message: "密码由6位数字、大小写字母和特殊符号组成!",
              pattern:/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{6,}$/,
//            message: '密码由6位数字、大小写字母和特殊符号组成!'
            },
            {
              validator: this.validateToNextPassword,
            },
          ],
        },
        confirmpassword: {
          rules: [
            {
              required: true,
              message: "请确认登录密码!",
            },
            {
              validator: this.compareToFirstPassword,
            },
          ],
        },
        provincecode:{
        	rules: [
            {
              required: true,
              message: "请选择学校所在省份!",
            },
          ],
        },
        realname:{
        		rules: [
            {
              required: true,
              message: "请输入学校名称!",
            },
          ],
        },
        address:{
        		rules: [
            {
              required: true,
              message: "请输入学校地址!",
            },
          ],
        },
        concactuser:{
        	rules: [
            {
              required: true,
              message: "请输入联系人姓名!",
            },
          ],
        },
        telephone:{
        	rules: [
            {
              required: true,
              message: "请输入联系人电话!",
            },
            {
              validator: this.getVerificationCodes,
            },
          ],
        },
        // verificationCode:{
        // 	rules: [
        //     {
        //       required: true,
        //       message: "请输入短信验证码!",
        //     },
        //   ],
        // }
      },
      disabled:true,
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      confirmDirty: false,
      model: {},
      provinceList: [],
      cityList: [],
      countdown: 60,
      city: "",
      schoollist: [],
      timeout: '',
      flag:true,
    };
  },

  mounted() {
    this.getProvince();
  },

  methods: {
  	onSuccess(){
  		this.visible=false;
      this.getMessage();
    	this.settime();
  	},
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  	onFail(){
//		this.$refs.slideBack.reset();
  	},
  	onRefresh(){
		  this.$refs.slideBack.reset();
  	},
  	searchSchool(value){
  		let that=this;
  		if(that.timeout){
  			 clearTimeout(that.timeout);
  			 this.schoollist=[];
  		}
		 that.timeout = setTimeout(()=>{
		 	 	let params={
  		  	name:value,
  		  	provincecode:this.form.getFieldValue("provincecode"),
  		  };
				mhSchool(params).then((res) => {
	        if (res.code == 200) {
	        	if(res.result.length>0){
	        		 that.schoollist = res.result;
	        	}else{
	        		that.form.setFieldsValue({
	        			realname:value,
	        		})
	        	}
	         
	        }
       });
		 }, 500);
     
  	},
  	debounce(func, wait) {
      let timeout;
      return function (...args) {
        if (timeout) clearTimeout(timeout);
          let isTime = !timeout;
          timeout = setTimeout(function () {
            timeout = null;
          }, wait);
          if (isTime) func.apply(this, args);
      };
    },
  	handleSearch(value) { 
  		if(value!=''){
  			this.searchSchool(value);
  		}
    },
    handleChanges(value) {
    },
    getProvince() {
      getAction("/pcity/queryByPid", { pid: 0 }).then((res) => {
        if (res.code == 200) {
          this.provinceList = res.result;
        }
      });
    },
    // 选择省份获取市
    provinceChange(id) {
    	this.disabled=false;
      getAction("/pcity/queryByPid", { pid: id }).then((res) => {
        if (res.code == 200) {
          this.cityList = res.result;
          this.form.setFieldsValue({
            city: "",
            realname:'',
          });
          this.schoollist=[];
        }
      });
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(["confirm"], { force: true });
      }
      callback();
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("password")) {
        callback("两次输入的密码不一样！");
      } else {
        callback();
      }
    },
    getVerificationCodes(rule, value, callback){
        if(!value || value=='' || value=='null' || value=='undefined'){
          callback("");
          // return 
        }
        var reg = "^1[0-9]{10}$"; //手机号码验证regEx:第一位数字必须是1，11位数字
		    var re = new RegExp(reg);
		    // 去掉空格
		    let telephone=value;
		    const trueVal = telephone.replace(/\s*/g, "");
		    if (!trueVal) {
		     	// this.$message.warning('请输入联系人电话');
          callback("请输入联系人电话");
		    }else if (!re.test(trueVal)) {
		     	// this.$message.warning('请输入正确的联系人电话');
           callback("请输入正确格式的联系人电话");
		      // return;
		    }else{
           callback();
        }
    },
    handleChange(value) {
      // console.log(`selected ${value}`);
    },
    getVerificationCode(e, phone) {
//    console.log(this.form.getFieldValue("telephone"));
//			 if(this.countdown!= 60){
//			 	  return false;
//			 }
      if(this.form.getFieldValue("telephone")=='' || this.form.getFieldValue("telephone")=='null' || this.form.getFieldValue("telephone")==undefined){
      	this.$message.warning('请输入联系人电话');
      	return;
      }else{
      	 var reg = "^1[0-9]{10}$"; //手机号码验证regEx:第一位数字必须是1，11位数字
		    var re = new RegExp(reg);
		    // 去掉空格
		    let telephone=this.form.getFieldValue("telephone");
		    const trueVal = telephone.replace(/\s*/g, "");
		    if (!trueVal) {
		     	this.$message.warning('请输入联系人电话');
		      return;
		    }
		    if (!re.test(trueVal)) {
		     	this.$message.warning('请输入正确的联系人电话');
		      return;
		    }
		    this.visible=true;
//		    console.log("11111111");
//		    if(this.countdown== 60){
//		    	 this.getMessage();
//		    }
      }
//    this.settime(e);
    },
    //倒计时
    settime() {
      if (this.countdown == 0) {
//      val.target.innerHTML = "|&nbsp;&nbsp;获取验证码";
        this.ishow=true;
        this.countdown = 60;
      } else {
      	this.ishow=false;
//      val.target.innerHTML = "&emsp;" + this.countdown + "s&emsp;";
        this.countdown--;
        var i = setTimeout(() => {
          this.settime();
        }, 1000);
      }
    },
    getMessage(){
    	let params={
    		phone:this.form.getFieldValue("telephone"),
    	};
    	getNoteCode(params).then(res => {
          if(res.code=='200'){
          	 	this.$message.success(res.message);
          }
     });
    },
    goindex(){
  		this.$router.push({path:'/home/index1'});
  	},
    goRegister() {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
//        console.log(this.model);
          let formData = Object.assign(this.model, values);
//        console.log(formData);
          postAction('/sys/user/register',formData).then(res => {
//          console.log(res)
            if(res.code=='200'){
            	this.$message.success(res.message);
            	// this.$router.push(`/home/login/${2}`);
            }else if(res.code=='0'){
            		this.$message.warning(res.message);
            }
          })
          //   this.confirmLoading = true;
          //   let formData = Object.assign(this.model, values);
          //   formData.password = md5(formData.password);
          //   formData.confirmpassword = md5(formData.confirmpassword);
          //   changePassword(formData)
          //     .then((res) => {
          //       if (res.success) {
          //         this.$message.success(res.message);
          //         this.$emit("ok");
          //       } else {
          //         this.$message.warning(res.message);
          //       }
          //     })
          //     .finally(() => {
          //       this.confirmLoading = false;
          //       this.close();
          //     });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding-bottom: 30px;
  padding-top:40px;
}
.top-background {
  width: 100%;
  height: 322px;
  background: url(~@/assets/images/new/top-background.png) no-repeat;
  background-size: 100% 100%;
  padding-top: 110px;
  margin-bottom: 26px;
  box-sizing: border-box;
  .main-title {
    background: url("~@/assets/images/new/title-img.png") no-repeat center
      center;
    background-size: auto auto;
    text-align: center;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
  .main-headline {
    text-align: center;
    margin-top: 26px;
  }
}
.form {
  width:800px;
  /*margin: 0 auto;*/
  position: relative;
  left:50%;
  margin-left:-520px;
  .register-button {
    width: 181px;
    height: 46px;
    background: #9A0B00;
    border-radius: 5px;
    text-align: center;
    line-height: 46px;
    color: #ffffff;
    font-size: 18px;
    cursor: pointer;
    margin: 0 auto;
    margin-top: 40px;
  }
  /deep/ .ant-form-item-control{
  	position:relative;
  }
  .tiplabel{
  	position:absolute;
  	width:100px;
  	right:-120px;
  	height:40px;
  	line-height: 20px;
  	top:-12px;
  	font-size:12px;
  	color:rgba(0,0,0,.5);
  }
  /deep/ .ant-form-item-label{
  	font-size:16px;
  }
  /deep/ .ant-input {
  	width:100%;
    height: 46px;
  }
  /deep/ .ant-select-selection--single {
    height: 46px;
  }
  /deep/ .ant-select-selection__rendered {
    line-height: 46px;
  }
  .city {
    display: inline-block;
    float: right;
    margin-bottom: 0;
    span {
      margin-right: 10px;
    }
  }
  .verification-code {
    position: relative;
    .verification-code-text {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translate(0, -50%);
      color: #9A0B00;
      cursor: pointer;
      z-index:11;
    }
    .ant-input {
      padding-right: 100px;
    }
  }
}
.home{
  	width:86px;
		height: 30px;
		background: rgba(255,255,255,0.2);
		border: 1px solid #1B42CB;
		border-radius: 4px;
		position: absolute;
		top:20px;
		right:100px;
		display: flex;
		padding:0px 10px;
		box-sizing: border-box;
		justify-content: space-around;
		align-items: center;
		img{
			width:13px;
			height:13px;
		}
}
.slideimg{
	width:330px;
	height:270px;
	background-color: #fff;
	position: absolute;
	top:-100px;
	left:-100px;
	/*border-:1px solid #333;*/
	/*box-shadow: 4px 4px rgba(0,0,0,0.6);*/
	box-shadow: 2px 2px 2px 5px rgba(0, 0, 0, 0.2);
	/*z-index:1111;*/
}
.slidesc{
	height:30px;
	line-height: 30px;
}
.slidexz{
		width:310px;
		height:216px;
		margin:0px auto;
}
.slide-verify-slider{
	margin-top:0px;
}
</style>